// 🔑 REVIEW AND SUBMIT'S ROWS, AND THE SUBMITTED FILE'S PAGE (LO plan v7): one fact per row, the sections in the order
// entered; a required answer left empty reads "Not entered" in amber. Edit on Review; read-only on the file's page.
// Labels sit beside values on desktop and above them on a phone (loSubmission.css). The rows are the server's
// (backend utils/loSubmissionReview) — this renders them and decides nothing.
import React from 'react';
import './loSubmission.css';

export default function LoReviewRows({ sections, onEdit, onView }) {
  return (
    <div data-testid="lo-review">
      {(sections || []).map((s) => (
        <div key={s.key} className="lo-rv" data-testid={`lo-rv-${s.key}`}>
          <div className="lo-rv-head">
            <span>{s.title}</span>
            {onEdit && s.editStep && s.key !== 'calculated' && (
              <button type="button" className="lo-link" data-testid={`lo-edit-${s.key}`} onClick={() => onEdit(s.editStep)}>Edit</button>
            )}
          </div>
          {s.summary != null && (
            <div className="lo-rv-row" data-testid="lo-rv-calculated-summary">
              <span className="lo-rv-value" style={{ gridColumn: '1 / -1' }}>
                {s.summary}{onView && <> · <button type="button" className="lo-link" data-testid="lo-view-calculated" onClick={onView}>View</button></>}
              </span>
            </div>
          )}
          {(s.groups || []).map((g, gi) => (
            <div key={gi}>
              {g.title && <div className="lo-rv-group">{g.title}</div>}
              {g.rows.map((r, i) => (
                <div key={`${r.label}-${i}`} className="lo-rv-row" data-testid="lo-rv-row" data-label={r.label}>
                  <span className="lo-rv-label">{r.label}</span>
                  <span className="lo-rv-value">
                    {r.missing ? <span className="lo-not-entered" data-testid="lo-not-entered">Not entered</span> : r.value}
                    {r.note && <span className="lo-help">{r.note}</span>}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
